export default {
  methods: {
    restoreData() {
      setTimeout(() => {
        this.crud = { ...this.$options.data().crud };
        this.$refs.form.resetValidation();
      }, 200);
    },
  },
};
